import React, { useCallback, useState } from 'react';
import TrueImpactIconText from 'shared/design-system/components/TrueImpactIconText';
import SummaryIcon from '../../../../ReportBuilder/Components/ImpactSummary/SummaryIcon';
import { faBrakeWarning, faTrash } from '@fortawesome/pro-light-svg-icons';
import { IndicatorSectionKey } from '../../../../ReportBuilder/Components/ImpactIndicator/utils';
import TrueImpactConfirmationDialog from 'shared/design-system/components/TrueImpactConfirmationDialog';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { FeedbackCommentBodyWithIndex } from '../../../utils';
import { ShowIndicatorFeedbackButton } from './ShowIndicatorFeedback';

const hideDeleteButton: IndicatorSectionKey[] = ['reach', 'succeed'];

interface ImpactDeleteStageProps {
  stageName: string;
  sectionKey: IndicatorSectionKey;
  className?: string;
  showSectionComments: boolean;
  sectionComments: FeedbackCommentBodyWithIndex[];
  handleDeleteSection: (sectionKey: IndicatorSectionKey) => unknown;
  setShowSectionComments: React.Dispatch<React.SetStateAction<boolean>>;
}

const ImpactDeleteStage: React.FC<ImpactDeleteStageProps> = ({
  sectionKey,
  stageName,
  handleDeleteSection,
  className,
  sectionComments,
  showSectionComments,
  setShowSectionComments,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const handleDelete = useCallback(() => {
    handleDeleteSection(sectionKey);
  }, [handleDeleteSection, sectionKey]);

  return (
    <>
      <SummaryIcon text={stageName} sectionKey={sectionKey} />
      {hideDeleteButton.includes(sectionKey) ? null : (
        <TrueImpactIconText
          label="Delete Stage"
          icon={faTrash}
          className={className}
          onClick={handleOpen}
        />
      )}
      {sectionComments.length > 0 && (
        <ShowIndicatorFeedbackButton
          show={showSectionComments}
          comments={sectionComments}
          className="section-comments-button"
          toggleShow={() => setShowSectionComments(s => !s)}
        />
      )}
      <TrueImpactConfirmationDialog
        open={open}
        icon={faBrakeWarning}
        handleClose={handleClose}
        next={{
          backgroundColor: 'critical',
          backgroundColorHover: 'criticalHover',
          text: `Delete ${stageName} Stage`,
          onClick: handleDelete,
        }}
        previous={{
          text: 'Cancel',
          onClick: handleClose,
        }}
      >
        <TrueImpactText align="center">
          Are you sure you want to delete <strong>{stageName}</strong> stage?
        </TrueImpactText>
      </TrueImpactConfirmationDialog>
    </>
  );
};

export default ImpactDeleteStage;
